<div class="grid-container mat-typography">
  <div class="container">
    <div class="info-container">
      <h1>Welcome to Treachery!</h1>
      <p>
        A game of deception, that can be played among 4 or more people.
      </p>
    </div>
    <div class="actions-container-container">
      <div>
        <div class="create-button-container">
          <button class="create-button" mat-raised-button color="accent" (click)="forensicApi.createGame()">
            Create Game 🚀
          </button>
        </div>
        <div class="actions-container">
          <mat-form-field color="accent">
            <input matInput placeholder="Game ID" #gameIdInput />
          </mat-form-field>
          <div class="join-button-container">
            <button mat-raised-button color="accent" (click)="joinGame(gameIdInput.value)">
              Join Game
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
